import AttackAngle from '../../images/TrackmanParameters/AttackAngle.png';
import BackswingTime from '../../images/TrackmanParameters/BackswingTime.png';
import BallSpeed from '../../images/TrackmanParameters/BallSpeed.png';
import Bounces from '../../images/TrackmanParameters/Bounces.png';
import Break from '../../images/TrackmanParameters/Break.png';
import Carry from '../../images/TrackmanParameters/Carry.png';
import ClubPath from '../../images/TrackmanParameters/ClubPath.png';
import ClubSpeed from '../../images/TrackmanParameters/ClubSpeed.png';
import DynamicLie from '../../images/TrackmanParameters/DynamicLie.png';
import DynamicLoft from '../../images/TrackmanParameters/DynamicLoft.png';
import FaceAngle from '../../images/TrackmanParameters/FaceAngle.png';
import FaceToPath from '../../images/TrackmanParameters/FaceToPath.png';
import ForwardSwingTime from '../../images/TrackmanParameters/ForwardSwingTime.png';
import Height from '../../images/TrackmanParameters/Height.png';
import ImpactHeight from '../../images/TrackmanParameters/ImpactHeight.png';
import ImpactOffset from '../../images/TrackmanParameters/ImpactOffset.png';
import LandingAngle from '../../images/TrackmanParameters/LandingAngle.png';
import LaunchAngle from '../../images/TrackmanParameters/LaunchAngle.png';
import LaunchDirection from '../../images/TrackmanParameters/LaunchDirection.png';
import LowPointDistance from '../../images/TrackmanParameters/LowPointDistance.png';
import LowPointHeight from '../../images/TrackmanParameters/LowPointHeight.png';
import LowPointSide from '../../images/TrackmanParameters/LowPointSide.png';
import RollPercent from '../../images/TrackmanParameters/RollPercent.png';
import Side from '../../images/TrackmanParameters/Side.png';
import SideTotal from '../../images/TrackmanParameters/SideTotal.png';
import SmashFactor from '../../images/TrackmanParameters/SmashFactor.png';
import SpeedDrop from '../../images/TrackmanParameters/SpeedDrop.png';
import SpinAxis from '../../images/TrackmanParameters/SpinAxis.png';
import SpinLoft from '../../images/TrackmanParameters/SpinLoft.png';
import SpinRate from '../../images/TrackmanParameters/SpinRate.png';
import StrokeLength from '../../images/TrackmanParameters/StrokeLength.png';
import SwingDirection from '../../images/TrackmanParameters/SwingDirection.png';
import SwingPlane from '../../images/TrackmanParameters/SwingPlane.png';
import SwingRadius from '../../images/TrackmanParameters/SwingRadius.png';
import Tempo from '../../images/TrackmanParameters/Tempo.png';
import Total from '../../images/TrackmanParameters/Total.png';
import { i18nInit } from 'i18nSetup';
import i18next from 'i18next';

i18nInit();

const parametersData = [
  {
    title: i18next.t('Club', { ns: 'trackmanParameters' }),
    submenu: [
      {
        title: i18next.t('AttackAngle', { ns: 'trackmanParameters' }),
        key: 'AttackAngle',
        image: AttackAngle,
        content: i18next.t('TheUpOrDownMovementOfTheClub', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('BackswingTime', { ns: 'trackmanParameters' }),
        key: 'BackSwingTime',
        image: BackswingTime,
        content: i18next.t('TheTimeTheClubHeadIsTravelingAway', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('ClubPath', { ns: 'trackmanParameters' }),
        key: 'ClubPath',
        image: ClubPath,
        content: i18next.t('TheInToOutOrOutToInMovementOfTheClubHead', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('ClubSpeed', { ns: 'trackmanParameters' }),
        key: 'ClubSpeed',
        image: ClubSpeed,
        content: i18next.t('TheLinearSpeedOfTheClubHead', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('DynamicLie', { ns: 'trackmanParameters' }),
        key: 'DynamicLie',
        image: DynamicLie,
        content: i18next.t('TheAngleOfTheLowerPortion', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('DynamicLoft', { ns: 'trackmanParameters' }),
        key: 'DynamicLoft',
        image: DynamicLoft,
        content: i18next.t('TheVerticalAngleOfTheClubFace', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('FaceAngle', { ns: 'trackmanParameters' }),
        key: 'FaceAngle',
        image: FaceAngle,
        content: i18next.t('TheDirectionTheClubFaceIsPointing', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('FaceToPath', { ns: 'trackmanParameters' }),
        key: 'FaceToPath',
        image: FaceToPath,
        content: i18next.t('TheAngleDifferenceBetweenTheReported', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('ForwardSwingTime', { ns: 'trackmanParameters' }),
        key: 'ForwardSwingTime',
        image: ForwardSwingTime,
        content: i18next.t('TheTimeTheClubHeadIsTravelingTowards', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('ImpactHeight', { ns: 'trackmanParameters' }),
        key: 'ImpactHeight',
        image: ImpactHeight,
        content: i18next.t('TheVerticalImpactLocationDistance', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('ImpactOffset', { ns: 'trackmanParameters' }),
        key: 'ImpactOffset',
        image: ImpactOffset,
        content: i18next.t('TheHoriziontalImpactLocationDistance', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('LowPointDistance', { ns: 'trackmanParameters' }),
        key: 'LowPointDistance',
        image: LowPointDistance,
        content:
          "<p class='topic-description'>Distance from the club head’s geometric center to the lowest point on the swing arc at the time of maximum compression. Low Point Distance provides a different way of describing Attack Angle.</p><h3 class='topic-subtitle'>What is the parameter used for? </h3><p class='topic-description'><span>Low Point Distance is useful when looking at where the club bottoms out. With a negative Attack Angle, the lowest point on the swing arch will be after impact and vice versa. Players and coaches can use Low Point Distance to work on improving strike consistency etc.</span></p><div class='parameter-links'><h3 class='topic-subtitle'>Learn more about the parameter here:</h3><p class='parameter-link'>Low Point blog post <a href='https://blog.trackmangolf.com/low-point/' title='Go to Low Point blog post' target='_blank'>Link</a></p><p class='parameter-link'>What is Low Point? <a href='https://blog.trackmangolf.com/what-is-low-point/' title='Go to What is Low Point blog post' target='_blank'>Link</a></p><p class='parameter-link'>Check your Low Point and improve your ball striking <a href='https://blog.trackmangolf.com/check-low-point-improve-ball-striking/' title='Go to the blog post to find out more' target='_blank'>Link</a></p><p class='parameter-link'>Six Trackman numbers every amateur golfer should know <a href='https://www.trackman.com/blog/golf/six-trackman-numbers-every-amateur-golfer-should-know' title='Go to the article about six Trackman numbers every amateur golfer should know' target='_blank'>Link</a></p><p class='parameter-link'>Top 8 ways to practice indoors with Trackman <a href='https://blog.trackmangolf.com/top-8-ways-to-practice-indoors-with-trackman/' title='Go to the article about Top 8 ways to practice indoors with Trackman' target='_blank'>Link</a></p><p class='parameter-link'>Bunker shot analysis and tips with the Trackman 4 <a href='https://blog.trackmangolf.com/bunker-shot-analysis-and-tips-with-the-trackman-4/' title='Go to the article about bunker shot analysis and tips with the Trackman 4' target='_blank'>Link</a></p><p class='parameter-link'>It's a matter of time <a href='https://blog.trackmangolf.com/its-a-matter-of-time/' title='Go to the blog post' target='_blank'>Link</a></p></div>",
      },
      {
        title: i18next.t('LowPointHeight', { ns: 'trackmanParameters' }),
        key: 'LowPointHeight',
        image: LowPointHeight,
        content:
          "<p class='topic-description'>The relative vertical distance of the club head position from <span style='color: #ec691a; display: inline'>just before impact</span> to where the swing would bottom out if there was no interaction between the ball or the ground.</p><h3 class='topic-subtitle'>What is the parameter used for? </h3><p class='topic-description'>Low Point Height is a useful tool to understand the depth of the swing. If a player’s Low Point is too high up, they may potentially be making poor contact with the ball (like hitting the ball thin). Conversely, if Low Point is too far down, it may result in hitting the ground before the ball. Working on Low Point Height along with the other Low Point measures is essential for cleaner strikes and higher consistency </p>",
      },
      {
        title: i18next.t('LowPointSide', { ns: 'trackmanParameters' }),
        key: 'LowPointSide',
        image: LowPointSide,
        content:
          "<p class='topic-description'>The relative horizontal distance of the club head measured perpendicular to the target line of the club head position from just before impact to where the swing would bottom out if there was no interaction between the ball or the ground. That is, the left/right distance between impact and where the club head bottoms out, when looking down the target line.</p><h3 class='topic-subtitle'>What is the parameter used for? </h3><p class='topic-description'>Low Point Side is useful in relation to the path of the swing. It can be visualized by thinking of it as where the lowest point of swing falls on either side of the target line. If the low point is too far to one side, it can indicate an outside-in or inside-out club path, and is therefore a helpful parameter to include when working on Club Path.</p>",
      },
      {
        title: i18next.t('SpinLoft', { ns: 'trackmanParameters' }),
        key: 'SpinLoft',
        image: SpinLoft,
        content: i18next.t('TheAngleBetweenTheDirectionOfTheClubHead', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('StrokeLength', { ns: 'trackmanParameters' }),
        key: 'StrokeLength',
        image: StrokeLength,
        content: i18next.t('TheDistanceTheClubHeadIsPulledBack', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SwingDirection', { ns: 'trackmanParameters' }),
        key: 'SwingDirection',
        image: SwingDirection,
        content: i18next.t('TheAngleBetweenTheBaseOfThePlane', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SwingPlane', { ns: 'trackmanParameters' }),
        key: 'SwingPlane',
        image: SwingPlane,
        content: i18next.t('TheVerticalAngleBetweenThePlane', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SwingRadius', { ns: 'trackmanParameters' }),
        key: 'SwingRadius',
        image: SwingRadius,
        content:
          "<p class='topic-description'>Radius of the swing arc, measured at knee height until just before impact, i.e. the club trajectory from about knee height until impact and then fitting a circle to it and measuring the radius.</p><h3 class='topic-subtitle'>What is the parameter used for? </h3><p class='topic-description'><span>Swing radius can be used as a measure when trying to maximize power generation in the swing or to optimize the club trajectory for pitch and chip shots. All else being equal, a longer club will produce a wider radius and potential for more speed.</span><span>Furthermore, having a consistent Swing Radius on pitch and chip shots may lead to cleaner and more consistent strike patterns.</span></p>",
      },
      {
        title: i18next.t('Tempo', { ns: 'trackmanParameters' }),
        key: 'Tempo',
        image: Tempo,
        content: i18next.t('TheBackswingTimeDividedByTheForwardSwingTime', { ns: 'trackmanParameters' }),
      },
    ],
  },
  {
    title: i18next.t('Launch', { ns: 'trackmanParameters' }),
    submenu: [
      {
        title: i18next.t('BallSpeed', { ns: 'trackmanParameters' }),
        key: 'BallSpeed',
        image: BallSpeed,
        content: i18next.t('TheSpeedOfTheGolfBall', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('Bounces', { ns: 'trackmanParameters' }),
        key: 'Bounces',
        image: Bounces,
        content: i18next.t('TheNumberOfBouncesOnTheGroundDuringTheSkidPhase', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('DPlaneTilt', { ns: 'trackmanParameters' }),
        key: 'DPlaneTilt',
        image: null,
        content:
          "<p class='topic-description'>D Plane Tilt is the tilt of the D Plane relative to the plumb line. D Plane Tilt is the expected spin axis disregarding any gear effect from off-center strike or other factors like ground contact of the club head during the collision with the ball, abnormal friction conditions etc. Thus, if face-to-path is zero, D Plane Tilt will be zero.</p><h3 class='topic-subtitle'>What is the parameter used for? </h3><p class='topic-description'><span>D Plane Tilt is a useful parameter to look at how club conditions impact the Spin Axis of the ball. As D Plane Tilt disregards gear effects and all other factors that may impact Spin Axis, it isolates the club conditions, that is, showing Spin Axis based on how the club is delivered only.</span></p><div class='parameter-links'><h3 class='topic-subtitle'>Learn more about the parameter here:</h3><p class='parameter-link'>Brian Manzella and the essential D-Plane <a href='https://blog.trackmangolf.com/brian-manzella-essential-d-plane/' title='Go to the blog post about Brian Manzella and the essential D-Plane' target='_blank'>Link</a></p><p class='parameter-link'>Understanding the D-Plne by James Leits <a href='https://blog.trackmangolf.com/understanding-d-plane-james-leitz/' title='Go to the blog post about understanding the D-Plne by James Leits' target='_blank'>Link</a></p></div>",
      },
      {
        title: i18next.t('LaunchAngle', { ns: 'trackmanParameters' }),
        key: 'LaunchAngle',
        image: LaunchAngle,
        content: i18next.t('TheVerticalAngleTheGolfBallTakes', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('LaunchDirection', { ns: 'trackmanParameters' }),
        key: 'LaunchDirection',
        image: LaunchDirection,
        content: i18next.t('TheHorizontalAngleTheGolfBallTakesOff', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SkidDistance', { ns: 'trackmanParameters' }),
        key: 'SkidDistance',
        image: null,
        content: i18next.t('TheDistanceTheBallIsBouncingSlidingUntilItStartsToRoll', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SmashFactor', { ns: 'trackmanParameters' }),
        key: 'SmashFactor',
        image: SmashFactor,
        content: i18next.t('TheRatioBetweenTheMeasured', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SpinAxis', { ns: 'trackmanParameters' }),
        key: 'SpinAxis',
        image: SpinAxis,
        content: i18next.t('TheAngleRelativeToTheHorizonOfTheImaginaryLine', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SpinRate', { ns: 'trackmanParameters' }),
        key: 'SpinRate',
        image: SpinRate,
        content: i18next.t('TheRateOfRotationOfTheGolfBall', { ns: 'trackmanParameters' }),
      },
    ],
  },
  {
    title: i18next.t('Flight', { ns: 'trackmanParameters' }),
    submenu: [
      {
        title: i18next.t('Carry', { ns: 'trackmanParameters' }),
        key: 'Carry',
        image: Carry,
        content: i18next.t('TheStraightLineDistanceBetweenWhereTheGolfBallWasLaunchedFromAndWhereItCrosses', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('CarrySide', { ns: 'trackmanParameters' }),
        key: 'CarrySide',
        image: Side,
        content: i18next.t('ThePerpendicularDistanceBetweenTheTargetLineAndWhereTheTrajectory', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('Curve', { ns: 'trackmanParameters' }),
        key: 'Curve',
        image: null,
        content: i18next.t('TheHorizontalSideMovement', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('HangTime', { ns: 'trackmanParameters' }),
        key: 'HangTime',
        image: null,
        content: i18next.t('TimeInSecondsToCarryFlat', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('HeightApex', { ns: 'trackmanParameters' }),
        key: 'HeightApex',
        image: Height,
        content: i18next.t('TheMaximumHeightOrApexOf', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('LandingAngle', { ns: 'trackmanParameters' }),
        key: 'LandingAngle',
        image: LandingAngle,
        content: i18next.t('TheAngleTheGolfBallLands', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('LastData', { ns: 'trackmanParameters' }),
        key: 'LastData',
        image: null,
        content: i18next.t('LastMeasurementOfBallFlight', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('Total', { ns: 'trackmanParameters' }),
        key: 'Total',
        image: Total,
        content: i18next.t('TheStraightLineDistanceBetweenWhereTheGolfBallWasLaunchedFromAndItsCalculated', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('TotalSide', { ns: 'trackmanParameters' }),
        key: 'FlightTotalSide',
        image: SideTotal,
        content: i18next.t('ThePerpendicularDistanceBetweenTheTargetLineAndTheGolfBall', { ns: 'trackmanParameters' }),
      },
    ],
  },
  {
    title: i18next.t('Roll', { ns: 'trackmanParameters' }),
    submenu: [
      {
        title: i18next.t('Distance', { ns: 'trackmanParameters' }),
        key: 'Distance',
        image: null,
        content: i18next.t('TheStraightLineDistanceBetweenWhereTheGolfBallWasLaunchedFromAndItsCalculatedRestingPoint', {
          ns: 'definitions',
        }),
      },
      {
        title: i18next.t('EntrySpeedDistance', { ns: 'trackmanParameters' }),
        key: 'EntrySpeedDistance',
        image: null,
        content: i18next.t('TheStraightLineDistanceBetweenWhereTheGolfBallWasLaunchedFromAndThePointOfEntrySpeed', {
          ns: 'trackmanParameters',
        }),
      },
      {
        title: i18next.t('RollSpeed', { ns: 'trackmanParameters' }),
        key: 'RollSpeed',
        image: null,
        content: i18next.t('TheSpeedAtThePointWhereTheBallStartsToRoll', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('RollPercent', { ns: 'trackmanParameters' }),
        key: 'RollPercent',
        image: RollPercent,
        content: i18next.t('TheAmountOfRollOnTheTotalPuttDistance', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SpeedDrop', { ns: 'trackmanParameters' }),
        key: 'SpeedDrop',
        image: SpeedDrop,
        content: i18next.t('ThePercentageDropInSpeedFromBallSpeedToRollSpeed', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('RollSide', { ns: 'trackmanParameters' }),
        key: 'RollSide',
        image: null,
        content: i18next.t('PerpendicularDistanceBetweenTheTargetLineAndWhereTheTrajectoryCrossesThePointOfEntrySpeed', {
          ns: 'definitions',
        }),
      },
      {
        title: i18next.t('TrackedDistance', { ns: 'trackmanParameters' }),
        key: 'TrackedDistance',
        image: null,
        content: i18next.t('TheStraightLineDistanceBetweenWhereTheGolfBallWasLaunchedFromAndToTheLastTrackingPoint', {
          ns: 'trackmanParameters',
        }),
      },
      {
        title: i18next.t('RollTotalSide', { ns: 'trackmanParameters' }),
        key: 'RollTotalSide',
        image: null,
        content: i18next.t('PerpendicularDistanceBetweenTheTargetLineAndWhereTheBallComesToAStop', { ns: 'trackmanParameters' }),
      },
    ],
  },
  {
    title: i18next.t('Green', { ns: 'trackmanParameters' }),
    submenu: [
      {
        title: i18next.t('Break', { ns: 'trackmanParameters' }),
        key: 'Break',
        image: Break,
        content: i18next.t('TheHorizontalSideMovementPerpendicularFromTheLaunchDirectionToTheBallReachesEntrySpeed', {
          ns: 'trackmanParameters',
        }),
      },
      {
        title: i18next.t('EfficientStimp', { ns: 'trackmanParameters' }),
        key: 'EfficientStimp',
        image: null,
        content: i18next.t('TheGreensSpeedOfTheIndividualPuttBasedOnTheAverageRollDeceleration', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('Elevation', { ns: 'trackmanParameters' }),
        key: 'Elevation',
        image: null,
        content: i18next.t('TheHeightDifferenceFromTheBallsStartingPositionToThePoointOfEntrySpeed', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SlopePercentSide', { ns: 'trackmanParameters' }),
        key: 'SlopePercentSide',
        image: null,
        content: i18next.t('TheAverageHorizontalInclinationOfTheSurface', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('SlopePercentRise', { ns: 'trackmanParameters' }),
        key: 'SlopePercentRise',
        image: null,
        content: i18next.t('TheAverageVerticalInclinationOfTheSurface', { ns: 'trackmanParameters' }),
      },
      {
        title: i18next.t('FlatStimp', { ns: 'trackmanParameters' }),
        key: 'FlatStimp',
        image: null,
        content: i18next.t('TheCalculationOfGreensGeneralSpeedBasedOnTheAverageRollDecelerationOfTheIndividualPutt', {
          ns: 'trackmanParameters',
        }),
      },
    ],
  },
] as const;

export default parametersData;

type TabTitle = 'Club' | 'Launch' | 'Flight' | 'Roll' | 'Green';

const parametersTitleToTabMapper = () => {
  let mappedTitles: Record<string, TabTitle> = {};
  parametersData.map((tab) => tab.submenu.map((topic) => (mappedTitles = { ...mappedTitles, [topic.key]: tab.title })));
  return mappedTitles;
};

export const parametersTitleToTab = parametersTitleToTabMapper();
